import { useContext } from 'react';
import { StorageContext } from '../providers/storage-provider';
export default function useStorage() {
  return useContext(StorageContext);
}